// flatten helper
export const flattenRow = (row) => {
    const calculated = typeof row.calculated_json === 'object' ? row.calculated_json : {};
    return { ...row, ...calculated };
};

// 담당자가 빈 캔(-CAN) 품목을 등록·삭제·수정하면 메인 품목의 관세가 함께 바뀐다.
// 서버가 재계산해 돌려준 메인 행들을 그리드 행에 병합해 새로고침 없이 반영한다.
export const applyRecalculatedSiblings = (rows, siblings = []) =>
    siblings.reduce(
        (acc, sibling) => acc.map((row) => (row.id === sibling.id ? { ...row, ...flattenRow(sibling) } : row)),
        rows,
    );

// unflatten helper (processRowUpdate 후 서버에 보낼 때)
const unflattenRow = (row) => {
    const { calculated_json, ...rest } = row;
    const calculatedFields = {};

    for (const key in rest) {
        // 'id'나 기존 calculated_json에 있던 키는 제외
        if (!(calculated_json && key in calculated_json) && key !== 'id') {
            calculatedFields[key] = rest[key];
            delete rest[key]; // 최상위에서 제거
        }
    }

    return { ...rest, calculated_json: calculatedFields };
};
